<template>
<div>
  <v-tabs class="pa-0 ma-0" v-model="activeTab" color="transparent" slider-color="accent" centered>
    <v-tab ripple>Edit</v-tab>
    <v-tab ripple>Preview</v-tab>
    <v-tab-item>
      <v-layout class="pt-3" row wrap justify-center>
        <v-flex class="pb-3" xs12 sm10 md6>
          <v-text-field
            label="Name"
            v-model.trim="newTask.name"
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs12 sm11 md10 lg8>
          <v-card class="pa-0 elevation-0">
            <r-quill :options="options" :content="newTask.text"></r-quill>
          </v-card>
        </v-flex>
        <v-flex class="px-2 pb-3 text-xs-center" xs12 sm11 md10 lg8>
          <v-btn @click.native="canUpdate" color="success" depressed>Save</v-btn>
          <v-btn @click.native="popup.type = 'Resetting', popup.show = true" color="error" flat><b>Reset</b></v-btn>
        </v-flex>
        <v-flex class="px-2 py-4" xs12 md10>
          <v-divider></v-divider>
        </v-flex>
        <v-flex class="px-2 pb-4 text-xs-center" xs12 md10>
          <v-btn @click.native="setupDeleteTask()" color="error" :disabled="deleting" :loading="deleting" large>Delete Task</v-btn>
        </v-flex>
      </v-layout>
    </v-tab-item>
    <v-tab-item>
      <v-layout class="pt-3" row wrap justify-center>
        <v-flex xs12 sm11 md10 lg8>
          <v-card class="px-2 mx-2 py-2 elevation-0">
            <div class="display-1 text-xs-center"><b>{{taskData.name}}</b></div>
            <v-divider class="my-3"></v-divider>
            <div class="quill-unit pb-4" v-html="taskData.text"></div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-tab-item>
  </v-tabs>

  <r-task-popup
    :popup="popup"
    :task-data="newTask"
    :deleting-data="toDelete"
  ></r-task-popup>
</div>
</template>

<script>
import TaskPopup from './TaskPopup.vue'
import Quill from '../general/Quill.vue'
import {quillEvent, contentEvent} from '../../main'
export default {
  components: {
    rQuill: Quill,
    rTaskPopup: TaskPopup
  },
  data: () => ({
    loading: false,
    deleting: false,
    activeTab: null,
    toDelete: {},
    taskData: {},
    newTask: {},
    newText: '',
    quillText: '',
    options: {
      modules: {
        toolbar: [
          [{'header': [1, 2, 3, 4, 5, 6, false]}],
          [],
          ['bold', 'italic', 'underline'],
          [],
          [{'align': []}],
          [],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [],
          [{'color': []}, {'background': []}],
          [],
          ['link']
        ]
      },
      theme: 'snow',
      placeholder: 'Enter Unit Content...'
    },
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    contentEvent.$off()
    this.load()
    quillEvent.$on('quillContent', data => {
      const quill = {...data}
      let d = quill.html
      while (d.includes('ql-align-center') || d.includes('ql-align-right')) {
        d = d.replace('ql-align-center', 'text-xs-center')
        d = d.replace('ql-align-right', 'text-xs-right')
      }
      this.newText = d
      this.quillText = quill.text
    })
    contentEvent.$on('reset', () => {
      this.load()
    })
    contentEvent.$on('updateTask', () => {
      this.updateTask()
    })
    contentEvent.$on('delete', () => {
      this.deleteTask()
    })
  },
  methods: {
    load () {
      this.loading = true
      const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      let sectionData = {}
      for (let s of this.$store.getters.sectionByContent(contentData.key)) {
        if (s.url === this.$route.params.sectionUrl) sectionData = s
      }
      for (let t of this.$store.getters.taskBySection(sectionData.key)) {
        if (t.url === this.$route.params.taskUrl) this.taskData = t
      }
      this.newTask = {
        ...this.taskData,
        text: this.taskData.text ? this.taskData.text : '',
        body: this.taskData.body ? this.taskData.body : ''
      }
      quillEvent.$emit('syncText', this.newTask.text)
      this.popup.show = false
    },
    canUpdate () {
      quillEvent.$emit('getContent')
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.newText === this.newTask.text && this.newTask.name.toLowerCase() === this.taskData.name.toLowerCase()) return
      if (this.newTask.name === '') {
        appMsg.msg = 'Please enter a name for the task'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.quillText.trim() === '') {
        appMsg.msg = 'Please type some text for reading in the task'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      this.popup = {
        show: true,
        type: 'Updating Task'
      }
    },
    updateTask () {
      let nameChanged = this.taskData.name !== this.newTask.name
      this.newTask.url = this.$store.getters.formatUrl(this.newTask.name.toLowerCase())
      const task = {
        ...this.newTask,
        text: this.newText,
        body: this.quillText
      }
      this.$store.dispatch('updateTask', task).then(() => {
        const appMsg = {
          type: 'success',
          msg: this.taskData.name + ' updated'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        if (nameChanged) this.$router.push('/content/' + this.$route.params.contentUrl + '/' + this.$route.params.sectionUrl)
        else this.load()
        this.popup.show = false
      })
    },
    setupDeleteTask () {
      this.toDelete = {...this.taskData}
      this.popup = {
        show: true,
        type: 'Deleting Task'
      }
    },
    deleteTask () {
      this.deleting = true
      const taskName = this.toDelete.name
      this.$store.dispatch('deleteTask', this.toDelete).then(() => {
        const appMsg = {
          type: 'success',
          msg: taskName + ' has been deleted'
        }
        this.deleting = false
        this.$router.push('/content/' + this.$route.params.contentUrl + '/' + this.$route.params.sectionUrl)
        this.$store.dispatch('showAppMsg', appMsg)
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.deleting = false
      })
    }
  }
}
</script>

<style lang="stylus">
   @import "~quill/assets/snow"
</style>



// WEBPACK FOOTER //
// src/components/content/ReadingTask.vue